/**
 * SandboxedHtml — renders an agent-written HTML file without giving it the app origin: the text is
 * fetched and shown through srcdoc in an iframe with an empty sandbox (opaque origin; no scripts,
 * forms, popups, plugins or top navigation). The file URL itself is never loaded in a frame or tab.
 */

import useFileText from './useFileText.js';
import { PREVIEW_SANDBOX, HTML_PREVIEW_BYTES } from './agentUi.js';

export default function SandboxedHtml({ url, title, className = 'wbd__pdf' }) {
  const doc = useFileText(url, Boolean(url), { limit: HTML_PREVIEW_BYTES, cut: false });
  if (!url) return null;
  if (doc.error) return <div className="wbd__empty">Could not load the file ({doc.error}).</div>;
  if (doc.tooLarge) return <div className="wbd__empty">Too large to preview here: use Download.</div>;
  if (doc.text === null) return <div className="wbd__empty">Loading…</div>;
  return (
    <iframe
      className={className}
      sandbox={PREVIEW_SANDBOX}
      srcDoc={doc.text}
      title={title}
      referrerPolicy="no-referrer"
    />
  );
}
